<template>
    <section class="page-content" v-if="false">
        <TopBackgroundComponent/>
        <DoctorListComponent/>
    </section>
</template>

<script setup>
    import TopBackgroundComponent from '../components/TopBackgroundComponent.vue';
    import DoctorListComponent from '@/components/doctor/DoctorListComponent.vue';
    window.scrollTo(0, 0);

    window.location.href = "https://melindahospital.com/dokter?facility_id=2910d2a1-697c-4ce7-9891-b36e3ecf7aa0";
</script>

<style scoped>
    /*  */
</style>